export const NODE_MAILER_API_PROD="https://bsk-security.com/send"
export const NODE_MAILER_API_DEV="http://localhost:4000/send"